//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'RIETE',
  data() {
    return {
      defaultJson: {
        "Metastatic cancer": "转移癌",
        "Thrombocytopenia": "血小板减少症",
        "moderate risk of fatal bleeding": "致命性出血中危",
        "GFR < 30 mL\/min": "GFR < 30 mL\/min",
        "immoHint": "定义为非手术患者诊断出静脉血栓栓塞（VTE）之前 2 月内除洗漱外长期卧床 ≥ 4 天。",
        "thromboHint": "血小板计数 < 100 x 10⁹\/L",
        "Abnormal prothrombin time": "凝血酶原时间（PT）异常",
        "anemiaHint": "定义为男性血红蛋白 < 13 g\/dL，女性血红蛋白 < 12 g\/dL。",
        "bleedingHint": "诊断出静脉血栓栓塞（VTE）之前 30 天内发生过大出血。",
        "low risk of fatal bleeding": "致命性出血低危",
        "Immobility ≥4 days": "制动 ≥ 4 天",
        "high risk of fatal bleeding": "致命性出血高危",
        "Distal DVT": "远端深静脉血栓（DVT）",
        "Recent major bleeding": "近期发生大出血",
        "Anemia": "贫血",
        "Age > 75 years": "年龄 > 75 岁"
      },
      form: {
        ageOver75: '0',
        cancer: '0',
        immobile: '0',
        bleeding: '0',
        prothrombin: '0',
        gfr: '0',
        thrombopenia: '0',
        anemia: '0',
        dvt: '0',
      },
      hasScore: false,
      disabled: false,
      Multifocal_Candida_Colonization_hint: "Candida is simultaneously isolated from various noncontagious foci:\n\nfeces\/rectal swabs or\nurine or\nrespiratory or\nskin or\noropharynx\/stomach",
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '0'
      } else {
        //  ageOver75 + (cancer ? 2 : 0) + immobile + (bleeding ? 1.5 : 0) + prothrombin + gfr + thrombopenia + anemia - dvt
        let result = form.ageOver75 + (form.cancer ? 2 : 0) + form.immobile + (form.bleeding ? 1.5 : 0) + form.prothrombin + form.gfr + form.thrombopenia + form.anemia - form.dvt

        self.hasScore = true
        return String(result)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/RIETE.vue